import SavedWorkOrders from "./SavedWorkOrders";

const FooterCreate = ({
  exitWindow,
  backWindow,
  createWO,
  btnDisabled = false,
  setChosenWo,
  showSavedWorkOrders,
  setShowSavedWorkOrders,
}) => {
  const CancelWizard = async () => {
    if (window.confirm("Är du säker på att du vill avbryta?")) {
      exitWindow();
    }
  };

  const closeSavedWorkOrders = async (state) => {
    setShowSavedWorkOrders(0);
  };
  return (
    <div className="divFooter">
      <button
        className={`btn btnNext ${btnDisabled ? "btnDisabeld" : ""}`}
        onClick={createWO}
        disabled={btnDisabled}
      >
        Skapa order
      </button>
      <button
        className={`btn btnNext ${btnDisabled ? "btnDisabeld" : ""}`}
        disabled={btnDisabled}
        onClick={backWindow}
      >
        Ändra
      </button>
      <button className="btn btnEnd" onClick={CancelWizard}>
        Avbryt
      </button>
      {showSavedWorkOrders ? (
        <SavedWorkOrders
          closeSavedWorkOrders={closeSavedWorkOrders}
          setChosenWo={setChosenWo}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default FooterCreate;
